<template>
  <div class="detail-content-layout">
    <div class="header">
      <div class="title">{{ label }}</div>
      <div class="action-area">
        <slot name="actionArea"></slot>
      </div>
    </div>
    <div class="main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailContentLayout",
  props: {
    label: {
      type: String,
      required: true,
    },
    onButtonLabel: {
      type: String,
      default: "新規追加 / 更新",
    },
    onButtonClick: {
      type: Function,
      default: () => {},
    },
    hideOnButtonClick: {
      type: Boolean,
      default: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleButtonClick() {
      if (this.isButtonDisabled) {
        return;
      }
      this.onButtonClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.detail-content-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  position: relative;
  background-color: $aisea-pure-white;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid $aisea-light-white;
    padding: 0px 24px;
    min-height: 60px;

    .title {
      color: #626262;
      font-family: "Hiragino Sans", -apple-system, Roboto, Helvetica, sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .action-area {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .btn-primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 24px;
      border-radius: 6px;
      border: 1px solid $aisea-blue;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: rgba(3, 155, 229, 0.05);
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      .text {
        color: $aisea-blue;
        text-align: center;
        font-family: "Hiragino Sans", -apple-system, Roboto, Helvetica,
          sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    padding: 24px;
    gap: 24px;
  }
}
</style>
